import type { FC, ReactNode } from 'react';
import { useStrategySelectorContext } from './StrategySelectorContext';
import styles from './StrategySelector.module.css';

interface StrategySelectorHeaderProps {
  children: ReactNode;
}

export const StrategySelectorHeader: FC<StrategySelectorHeaderProps> = ({ children }) => {
  const { toggleExpanded } = useStrategySelectorContext();

  return (
    <div
      className={styles.sectionHeader}
      role="button"
      tabIndex={0}
      onClick={toggleExpanded}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleExpanded();
        }
      }}
    >
      {children}
    </div>
  );
};
